import { sendAxonEvent } from 'helpers/sendAxonEvent'
import { useEffect } from 'react'
import { useShallow } from 'zustand/shallow'
import { useZustandStore } from 'zustandGlobalStore'

export const useAxonPixelEvent = (): void => {
  const { leadId, email } = useZustandStore(
    useShallow((state) => ({
      leadId: state.lead?.id || '',
      email: state.lead?.email || state.inputEmail || '',
    })),
  )

  useEffect(() => {
    sendAxonEvent('page_view')
  }, [leadId, email])
}
